
import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SAUTableModule } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { Urls } from '@/apiConnection/urls';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { MeasureFormComponent } from '../measure-form/measure-form.component';

@Component({
  imports: [
    ReactiveFormsModule,
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
  ],
  templateUrl: './measure-list.page.html',
  styleUrl: './measure-list.page.scss',
  encapsulation: ViewEncapsulation.None
})
export class MeasureListPage {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  public url = Urls.urls.measurements;

  public headers = [
    { name: 'NOMBRE', key: 'name' },
    { name: 'DESCRIPCIÓN', key: 'description' },
  ];

  openEditForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(MeasureFormComponent, {});
    modalRef.componentInstance.id = item.id;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'medida';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

}
